module.exports = __webpack_public_path__ + "img/vr.52d190c1.jpg";